module.exports = __webpack_public_path__ + "assets/img/ic-message-blue.db6eccb5.svg";